import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../intl.js";
import e from "../../../core/Error.js";
import { clone as t } from "../../../core/lang.js";
import r from "../../../core/Logger.js";
import { isSome as i } from "../../../core/maybe.js";
import { getMetersPerUnitForSR as n } from "../../../core/unitUtils.js";
import l from "../../../geometry/Polygon.js";
import { createExtentFromGeometry as o, scaleExtent as s } from "./geometryUtils.js";
import { substitute as u } from "../../../intl/substitute.js";
import { formatDate as a } from "../../../intl/date.js";
var c = /https?:\/\/services.*\.arcgis\.com/i,
    d = /(?:\{([^}]+)\})/g,
    f = r.getLogger("esri.widgets.Search.support.layerSearchUtils");

function m(t, r) {
  var _t$exactMatch = t.exactMatch,
      i = _t$exactMatch === void 0 ? !1 : _t$exactMatch,
      l = t.location,
      o = t.maxResults,
      s = t.spatialReference,
      u = t.source,
      a = t.sourceIndex,
      c = t.suggestResult,
      d = t.view,
      m = u.layer,
      g = u.filter,
      v = u.zoomScale,
      b = d && d.scale,
      j = p(u, d),
      T = r && r.signal;
  return h(m).then(function () {
    var e = m.popupTemplate;
    return e ? e.getRequiredFields(m.fieldsIndex) : null;
  }).then(function (t) {
    var r, p, h;
    var R = m.objectIdField,
        S = m.returnZ,
        D = x(u);
    if (!$(m, D)) throw f.error("invalid-field: displayField is invalid."), new e("getResults():invalid-field", "displayField is invalid.");
    var E = t && t.length ? t : [D],
        M = u.outFields || E,
        O = y(M);
    -1 !== M.indexOf(R) || O || M.push(R), null != (r = m.floorInfo) && r.floorField && M.push(m.floorInfo.floorField);
    if (!(O || w(m, M))) throw f.error("invalid-field: outField is invalid."), new e("getResults():invalid-field", "outField is invalid.");
    var C = m.createQuery(),
        N = u.orderByFields;

    if (N && (C.orderByFields = N), s) {
      C.outSpatialReference = s;

      var _e = 1 / n(s);

      _e && (C.maxAllowableOffset = _e);
    }

    var U = "mesh" === m.geometryType || "multipatch" === m.geometryType,
        q = (null == (p = m.capabilities) || null == (h = p.data) ? void 0 : h.supportsZ) && !U;
    if (C.returnZ = q && !1 !== S, C.returnGeometry = !0, C.multipatchOption = U ? "xyFootprint" : null, M && (C.outFields = M), l) C.geometry = l;else if (c.key) C.objectIds = [c.key];else {
      var _t = u.searchFields || [D];

      if (!w(m, _t)) throw f.error("invalid-field: search field is invalid."), new e("getResults():invalid-field", "search field is invalid.");
      F(m) && (C.num = o), j && (C.geometry = j);
      if (!c.text.trim()) return [];

      var _u$prefix = u.prefix,
          _r = _u$prefix === void 0 ? "" : _u$prefix,
          _u$suffix = u.suffix,
          _n = _u$suffix === void 0 ? "" : _u$suffix,
          _l = L({
        searchTerm: I("".concat(_r).concat(c.text).concat(_n)),
        layer: m,
        searchFields: _t,
        filter: g,
        exactMatch: i,
        type: "search"
      });

      if (!_l) return [];
      C.where = _l;
    }
    return m.queryFeatures(C, {
      signal: T
    }).then(function (e) {
      return k(e, d, u, a, D, b, v);
    });
  });
}

function g(t, r) {
  var i = t.source,
      n = t.spatialReference,
      l = t.view,
      o = t.suggestTerm,
      s = t.maxSuggestions,
      u = t.sourceIndex,
      a = t.exactMatch,
      c = i.layer,
      m = i.filter,
      g = r && r.signal,
      v = p(i, l);
  return h(c).then(function () {
    if (!F(c)) return [];
    var t = x(i),
        r = i.searchFields || [t],
        l = [];
    i.suggestionTemplate ? i.suggestionTemplate.replace(d, function (e, t) {
      return l.push(t), e;
    }) : l.push(t);
    var p = y(l);
    -1 !== l.indexOf(c.objectIdField) || p || l.push(c.objectIdField);
    var h = $(c, t),
        b = p || w(c, l),
        j = w(c, r);
    if (!h) throw f.error("invalid-field: displayField is invalid."), new e("getSuggestions():invalid-field", "displayField is invalid.");
    if (!b) throw f.error("invalid-field: outField is invalid."), new e("getSuggestions():invalid-field", "outField is invalid.");
    if (!j) throw f.error("invalid-field: search field is invalid."), new e("getSuggestions():invalid-field", "search field is invalid.");
    var T = c.createQuery(),
        R = i.orderByFields;
    R && (T.orderByFields = R), T.outSpatialReference = n, T.returnGeometry = !1, T.num = s, T.outFields = l, v && (T.geometry = v);
    if (!o.trim()) return [];
    var _i$prefix = i.prefix,
        S = _i$prefix === void 0 ? "" : _i$prefix,
        _i$suffix = i.suffix,
        D = _i$suffix === void 0 ? "" : _i$suffix,
        E = L({
      searchTerm: I("".concat(S).concat(o).concat(D)),
      layer: c,
      searchFields: r,
      filter: m,
      exactMatch: a,
      type: "suggest"
    });
    return E ? (T.where = E, c.queryFeatures(T, {
      signal: g
    }).then(function (e) {
      return C(e, i, u, t);
    })) : [];
  });
}

function p(e, t) {
  var r = e.filter,
      i = e.withinViewEnabled,
      n = t && t.extent;
  return r && r.geometry || (i && n ? n : void 0);
}

function y(e) {
  return e && -1 !== e.indexOf("*");
}

function h(_x) {
  return _h.apply(this, arguments);
}

function _h() {
  _h = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = e;

            if (!_context.t0) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return e.load();

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _h.apply(this, arguments);
}

function F(e) {
  var t, r, i;
  return null != (t = null == e || null == (r = e.capabilities) || null == (i = r.query) ? void 0 : i.supportsPagination) && t;
}

function v(e) {
  var t, r, i, n;
  return null != (t = null == e || null == (r = e.fieldsIndex) || null == (i = r.fields) || null == (n = i.find(function (e) {
    return "string" === e.type;
  })) ? void 0 : n.name) ? t : "";
}

function x(e) {
  return e.displayField || e.layer.displayField || v(e.layer);
}

function w(e, t) {
  return !(!e || !t) && t.every(function (t) {
    return $(e, t);
  });
}

function $(e, t) {
  return !!e.getField(t);
}

function b(e) {
  for (var _t2 = 0; _t2 < e.length; _t2++) {
    if (e.charCodeAt(_t2) > 255) return !0;
  }

  return !1;
}

function j(e, t, r) {
  var i = null;
  var n = e.codedValues;
  return n && n.some(function (e) {
    var n = e.name,
        l = r ? n : n.toLowerCase();
    return (r ? t : t.toLowerCase()) === l && (i = e.code.toString(), !0);
  }), i;
}

function I(e) {
  return e.replace(/\'/g, "''");
}

function T(e, t) {
  var r = t && t.where;
  return r ? "(".concat(e, ") AND (").concat(r, ")") : e;
}

function R(_ref) {
  var e = _ref.currentTerm,
      t = _ref.field,
      r = _ref.filter,
      i = _ref.exactMatch,
      n = _ref.url,
      l = _ref.type;
  var o = t.type,
      s = t.name;

  if ("string" === o || "date" === o || "global-id" === o) {
    var _t3 = c.test(n),
        _o = _t3 && b(e) ? "N" : "";

    if (i && "search" === l) return T("".concat(s, " = ").concat(_o, "'").concat(e, "'"), r);

    var _u = _t3 ? s : "UPPER(".concat(s, ")"),
        _a = _t3 ? e : e.toUpperCase();

    return T("".concat(_u, " LIKE ").concat(_o).concat(i ? "'".concat(_a, "%'") : "'%".concat(_a, "%'")), r);
  }

  if ("oid" === o || "small-integer" === o || "integer" === o || "single" === o || "double" === o) {
    var _t4 = Number(e);

    return isNaN(_t4) ? null : T("".concat(s, " = ").concat(_t4), r);
  }

  return T("".concat(s, " = ").concat(e), r);
}

function S(e, t) {
  return e ? " OR (".concat(t, ")") : "(".concat(t, ")");
}

function L(_ref2) {
  var e = _ref2.searchTerm,
      t = _ref2.layer,
      r = _ref2.searchFields,
      i = _ref2.filter,
      n = _ref2.exactMatch,
      l = _ref2.type;
  var o = t.definitionExpression,
      s = t.url;
  var u = "";
  return e && r && r.forEach(function (r) {
    var o = t.getField(r),
        a = "function" == typeof t.getFieldDomain && t.getFieldDomain(r),
        c = (a && "coded-value" === a.type ? j(a, e, n) : null) || e || null;

    if (null !== c) {
      var _e2 = R({
        currentTerm: c,
        field: o,
        filter: i,
        exactMatch: n,
        url: s,
        type: l
      });

      _e2 && (u += S(u, _e2));
    }
  }), o ? "(".concat(o, ") AND (").concat(u, ")") : u;
}

function D(e, t) {
  var r = null;
  var i = e.codedValues;
  return i && i.length && i.some(function (e) {
    return e.code === t && (r = e.name, !0);
  }), r;
}

function E(e, t) {
  return e[Object.keys(e).find(function (e) {
    return e.toLowerCase() === t.toLowerCase();
  })];
}

function M(e, t, r) {
  var i = e.sourceLayer,
      n = e.attributes,
      l = "function" == typeof i.getFieldDomain && i.getFieldDomain(r);
  if (t) return u(t, n);

  if (r && n) {
    var _e3 = i.getField(r),
        _t5 = E(n, r);

    return null == _t5 ? "" : l && "coded-value" === l.type ? D(l, _t5) : "date" === (null == _e3 ? void 0 : _e3.type) ? a(new Date(_t5)) : "number" == typeof _t5 ? _t5.toString() : "string" != typeof _t5 ? "" : _t5.trim();
  }

  return "";
}

function O(e, t, r, i) {
  var n = e.sourceLayer,
      l = e.attributes,
      o = n.objectIdField,
      s = l[o];
  return {
    text: M(e, t.suggestionTemplate, i),
    key: s,
    sourceIndex: r
  };
}

function C(e, t, r, i) {
  return e.features.map(function (e) {
    return O(e, t, r, i);
  });
}

function N(e, r, n, u, a, c, d) {
  var f = e.clone(),
      m = e.sourceLayer,
      g = m && m.objectIdField,
      p = g && e.attributes[g],
      y = M(e, n.searchTemplate, a),
      h = o(f.geometry, r, c),
      F = "number" == typeof d ? s(t(h), r, d) : h,
      v = e.clone();
  return i(F) && (v.geometry = l.fromExtent(F)), {
    extent: F,
    target: v,
    feature: f,
    key: p,
    name: y,
    sourceIndex: u
  };
}

function k(e, t, r, i, n, l, o) {
  return e.features.map(function (e) {
    return N(e, t, r, i, n, l, o);
  });
}

export { m as getResults, g as getSuggestions };